module.exports = __webpack_public_path__ + "fonts/Decimal-Black.775b7d4.woff";